class Helper {
    
    /**
     * Emette un log nella console
     * Se il messaggio è un oggetto o un array, utilizza la vista a tabella di console.table.
     * Il parametro filter (array) permette di filtrare quali campi mostrare.
     * 
     * @param message mixed messaggio da stampare
     * @setting object di configurazioni {
     *      filter: array con le chiavi degli elementi da mostrare
     *      mode: string (default|table) stampa il messaggio in modalità standard o tabellare. Opera solo se il messaggio è di tipo object o array.
     * }
     */
    debug(message,setting) {
        return;
        
        // settings
        if(!setting) setting = {};
        setting.filter = setting.filter || [];
        setting.mode = setting.mode || 'default';
        
        // --------------------
        
        // stringa o numero
        if(typeof message === 'string' || typeof message === 'number') {
            console.log('EIOVISUAL' + '\n',message);
        }
        
        // oggetto o array
        if(typeof message === 'object' || typeof message === 'array') {
            
            if(setting.filter && setting.mode == 'default') {
                console.log('EIOVISUAL' + '\n',message);
            }
            
            if(setting.filter && setting.filter == 'table') {
                console.table(message,setting.filter);
            }
        }
    }

}

// export
export default new Helper();